var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":_vm.type,"icon-left":_vm.icon},on:{"click":_vm.sendHex}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }